// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "polls-" + chunkId + ".js?v=" + {"src_js_components_Settings_UserSettings_FeatureSettings_vue":"51ca3781eae39e5ffe12","src_js_components_Settings_UserSettings_StyleSettings_vue":"70d6467a97dcaf4084b5","src_js_components_Settings_UserSettings_PerformanceSettings_vue":"c7c313923108a32405df"}[chunkId] + "";
};